import React from 'react';

import { Box } from '@mui/material';

import { useGlobalProducts } from 'components/BusinessToolForm/hooks/useGlobalProducts';
import { ProductVolumesTable } from 'components/BusinessToolForm/Sections/BusinessOperations/ProductionSection/ProductionPlansAndSpecifics/components/ProductVolumesTable';
import {
  PRODUCTION_NAMES,
  prefix as productionPrefix,
} from 'components/BusinessToolForm/Sections/BusinessOperations/ProductionSection/utils/form';
import { GLOBAL_PRODUCTS_NAME } from 'components/BusinessToolForm/Sections/Global/form';

import { concatWithDot } from 'helpers/string';

import { SalesPlanProductTable } from './components/SalesPlanProductTable';
import { SalesPlanProductVolumes } from './components/SalesPlanProductVolumes';
import { IProductsAndRevenueVolume } from './types';
import { prefix, REVENUE_PLAN_NAMES } from '../../utils/form';

export const ProductsAndRevenueVolume: React.FC<IProductsAndRevenueVolume> = ({ disabled = false }) => {
  const { products, revenuePlanFields, handleAddProduct, handleRemoveProduct, productionFields } = useGlobalProducts();

  const tableName = concatWithDot(prefix, REVENUE_PLAN_NAMES.PLANNED_PRODUCTS_VOLUME);
  const productionTableName = concatWithDot(productionPrefix, PRODUCTION_NAMES.PLANNED_PRODUCTS_VOLUME);

  return (
    <Box>
      <SalesPlanProductVolumes
        productsName={GLOBAL_PRODUCTS_NAME}
        fields={products}
        disabled={disabled}
        onAddRow={handleAddProduct}
        onRemoveRow={handleRemoveProduct}
      />
      <SalesPlanProductTable tableName={tableName} fields={revenuePlanFields} disabled={disabled} />
      <ProductVolumesTable tableName={productionTableName} fields={productionFields} disabled={disabled} />
    </Box>
  );
};
